import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum IncidentSeverity {
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

export enum IncidentStatus {
  ACTIVE = "active",
  RESOLVED = "resolved",
}

export enum IncidentProduct {
  OMS = "oms",
  ALL = "all",
  MARKETING = "marketing",
  RETURNS = "returns",
  CONVERSION = "conversion",
  RECOMMERCE = "recommerce",
  SUPPORT = "support",
}

export const IncidentSchema = z.object({
  _id: zExt.objectId(),
  title: z.string(),
  message: z.string(),
  severity: createEnum(IncidentSeverity, { enumName: "IncidentSeverity" }),
  status: createEnum(IncidentStatus, { enumName: "IncidentStatus" }),
  type: createEnum(IncidentProduct, { enumName: "IncidentProduct" }),
  affectedTeams: z.array(zExt.objectId()).nullish(),
  isGlobal: z.boolean(),
  isTest: z.boolean(),
  adminOnly: z.boolean().optional(),
  routeScoped: z.boolean().optional(),
  createdAt: z.date(),
  resolvedAt: z.date().nullish(),
  updatedAt: z.date(),
  createdBy: z.string().nullish(),
  notes: z.string().nullish(),
  publicUrl: z.string().nullish(),
});
export type Incident = z.infer<typeof IncidentSchema>;
export interface IIncident extends z.ZodType<Incident> {}

const severityOrder = [
  IncidentSeverity.ERROR,
  IncidentSeverity.WARNING,
  IncidentSeverity.INFO,
];

export const incidentSort: (a: Incident, b: Incident) => number = (a, b) => {
  // severity desc, createdAt desc
  if (a.severity !== b.severity) {
    return (
      severityOrder.indexOf(a.severity) - severityOrder.indexOf(b.severity)
    );
  }
  return b.createdAt.getTime() - a.createdAt.getTime();
};
